module.exports = __webpack_public_path__ + "img/logo.c078309a.svg";